// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b9ba2d44","977":"45030bc8"}[chunkId] + ".chunk.js";
};